import { supabase } from "@/integrations/supabase/client";

export type CheckoutRequest =
  | { purpose: "deposit"; quote_id: string }
  | { purpose: "vin_report"; vin: string };

/** Only ever send the customer to Paystack's hosted checkout. */
export function isPaystackCheckoutUrl(raw: unknown): raw is string {
  if (typeof raw !== "string") return false;
  try {
    const u = new URL(raw);
    return (
      u.protocol === "https:" &&
      (u.hostname === "paystack.com" || u.hostname.endsWith(".paystack.com"))
    );
  } catch {
    return false;
  }
}

export function formatGhs(amount: number): string {
  return `GHS ${amount.toLocaleString("en-GH", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

/** Ask the server to create a payment; returns a checkout URL or a user-facing error. */
export async function createCheckout(
  req: CheckoutRequest,
): Promise<{ url: string } | { error: string }> {
  const { data, error } = await supabase.functions.invoke("paystack-init", {
    body: req,
  });
  // supabase-js puts non-2xx bodies inside error.context; surface our friendly message
  if (error) {
    let message = "Payment could not be started. Please try again.";
    try {
      const body = await (error as { context?: Response }).context?.json();
      if (body?.error) message = String(body.error);
    } catch {
      /* keep default */
    }
    return { error: message };
  }
  const url = (data as { authorization_url?: unknown } | null)
    ?.authorization_url;
  if (!isPaystackCheckoutUrl(url))
    return { error: "Payment could not be started. Please try again." };
  return { url };
}
